import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BasePage } from "pages/base-page";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class SystemAdminService extends BasePage {
  baseEmployeeActivityUrl: string;
  searchEndpoint: string;
  createEndpoint: string;

  constructor(
    public http: HttpClient,
    public stateData: StateManagementService,
    config: ConfigurationService
  ) {
    super(stateData);
    this.baseEmployeeActivityUrl =
      config.getConfig().apiUrl + "/employee-activity";
    this.searchEndpoint = this.baseEmployeeActivityUrl + "/search";
    this.createEndpoint = this.baseEmployeeActivityUrl + "/activities";
  }

  getActivities(request: any) {
    return this.http.post(this.searchEndpoint, request);
  }

  createActivity(request: any) {
    return this.http.post(this.createEndpoint, request);
  }
  deleteActivity(request: any) {
    return this.http.post(this.createEndpoint, request);
  }
}



// WEBPACK FOOTER //
// ./src/providers/system-admin/system-admin.service.ts